import { Card, CardContent } from "@/components/ui/card";

export interface DistanceCardProps {
  miles: number;
  minutes: number;
  originLabel: string;
}

export function DistanceCard({ miles, minutes, originLabel }: DistanceCardProps): React.ReactElement {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  const timeStr = hours > 0 ? `${hours}h ${mins}m` : `${mins}m`;
  return (
    <Card>
      <CardContent className="flex flex-col gap-1 p-4">
        <div className="text-2xl font-semibold">
          {miles.toFixed(1)} mi · {timeStr} drive
        </div>
        <div className="text-sm text-muted-foreground">from {originLabel}</div>
      </CardContent>
    </Card>
  );
}
